import { Stack, Divider, Text } from '@chakra-ui/react'
import { CourseProgressStepCircle } from './CourseProgressStepCircle'
import { SurveyService } from '../services/SurveyService'

export const CourseProgressStep = (props: {
  title: string
  questionCount: number
  answeredQuestionCount: number
  isActive: boolean
  isLastStep: boolean
  isFirstStep: boolean
  onClick: () => void
}) => {

  const { isActive, isLastStep, isFirstStep } = props

  const title =  SurveyService.getPageTitleFromInfo(props)

  return (
    <Stack fontSize='small' spacing="2" direction={{ base: 'row', md: 'column' }} flex="1">
      <Stack spacing="0" align="center" direction={{ base: 'column', md: 'row' }}>
        <Divider
          display={'initial'}
          orientation='horizontal'
          borderWidth="1px"
          borderColor={isFirstStep ? 'transparent' : 'gray'}
        />
        <CourseProgressStepCircle
          cursor='pointer'
          onClick={props.onClick}
          isActive={isActive}
          questionCount={props.questionCount}
          answeredQuestionCount={props.answeredQuestionCount}
        />
        <Divider
          orientation='horizontal'
          borderWidth="1px"
          borderColor={isLastStep ? 'transparent' : 'gray'}
        />
      </Stack>
      <Stack textAlign='center' onClick={props.onClick} cursor='pointer' spacing="0.5" pb={!isLastStep ? '2' : '0'} align={'center'}>
        <Text color="fg.emphasized" fontWeight={isActive ? 700 : 500}>{title}</Text>
      </Stack>
    </Stack>
  )
}